import { checkStripe } from "../Common/StripeChecker";
import { Section } from "../jobs-flow/Section";
import { SaveButton } from "../components/SaveButton";

const roundCurrency = value => Math.round((Number(value) + Number.EPSILON) * 100) / 100;

export default {
    init() {
        this.markAsPaidCash();
        this.createCharge();
        this.refunds();
        this.removeWarning();
        this.autoRefresh('/payments');
        this.initPagination('/payments');
        this.serviceInvoiceInfoModal();
    },
    markAsPaidCash() {
        $('body').on('click', '.payments__charge-buttons',function(e){
            e.preventDefault();
            let currentElem = $(this);
            let payment_id = currentElem.data('order-id');
            let action = currentElem.data('action');
            let type = currentElem.data('type')

            const paymentRequest = () => {
                $.ajax({
                    type: 'GET',
                    url: '/payments/' + payment_id + '/' + action + (type ? `/${type}` : ''),
                    success: function (response) {
                        // if (action == 'paid-cash') {
                        //     window.location.reload();
                        // } else {
                            $('#ajax_modals_containter').html(response);
                            $('.'+action+'-modal').modal('show');
                            Inputmask("[-]{0,1}9{*}[.]9{0,2}", { placeholder: "-", greedy: false }).mask(`#additional_input`);
                            if (parseFloat($('.charge-modal #total-value').text()) <= 0) {
                                $('.charge-modal .charge-btn').attr('disabled', 'disabled');
                            }
                            if (parseFloat($('.manual-charge-modal .total_value_manual').text()) <= 0) {
                                $('.manual-charge-modal .charge-btn').attr('disabled', 'disabled');
                            }
                            if (parseFloat($('.paid-cash-modal #total-value').text()) <= 0) {
                                $('.paid-cash-modal .paid-cash-btn').attr('disabled', 'disabled');
                            }
                        //}
                    }
                });
            }

            if (action == 'paid-cash') paymentRequest();
            else checkStripe(paymentRequest);

        });
        $('body').on('click', '.confirm-subscription-appointment', (e)=>{
            const button_elem = $(e.currentTarget)
            const order_id = button_elem.data('id');

            $.ajax({
                method: "POST",
                url: `/service-list/confirm-subscription-appointment`,
                data:{ order_id: order_id},
                beforeSend:()=>{
                    button_elem.attr('disabled', 'true');
                },
                success: function (response) {
                    button_elem.addClass('d-none');
                }
            });
        });
    },

    createCharge(){
        //$('#additional_input').mask('999999.99');
        $('body').on('input','.manual-charge-modal #additional_input', (e) => {
            if ($(e.target).val()>0) {
                $('.manual-charge-modal .sub_total_manual').text(parseFloat($(e.target).val()).toFixed(2));
                if ($('[data-tax-percent]').length>0) {
                    $('.tax_value_manual').text(this.calculateTax($(e.target).val(), $('[data-tax-percent]').val()));
                    $('.total_value_manual').text((parseFloat($('.manual-charge-modal .sub_total_manual').text()) + parseFloat($('.tax_value_manual').text())).toFixed(2));
                }
                if($('.manual-charge-modal .customer-payment-warning').length == 0){
                    $('.manual-charge-modal .charge-btn').removeAttr('disabled');
                }
            } else {
                $('.manual-charge-modal .charge-btn').attr('disabled', 'disabled');
                $('.manual-charge-modal .sub_total_manual').text('0.00');
                $('.tax_value_manual').text('0.00');
                $('.total_value_manual').text('0.00');
            }
        });
        $('body').on('input','.charge-modal #additional_input, .service-invoice-modal #additional_input, .paid-cash-modal #additional_input', function() {
            const $parentForm = $(this).closest('.charge-modal, .service-invoice-modal, .paid-cash-modal');
            let tips = 0, tax = 0, sub_total=0;
            const additionalAmount = parseFloat($(this).val()) || 0;
            const baseTax = parseFloat($parentForm.find('[data-base-tax]').val()) || 0;

            sub_total = parseFloat($parentForm.find('#sub_hidden_value').val()) || 0;
            if ($(this).val()>0) {
                sub_total += additionalAmount;
                $parentForm.find('.service-estimate-pricing__sub-total-value').text(sub_total.toFixed(2));
            } else {
                $parentForm.find('.service-estimate-pricing__sub-total-value').text(sub_total.toFixed(2));
            }

            const taxPercent = parseFloat($parentForm.find('[data-tax-percent]').val()) || 0;
            if (taxPercent > 0) {
                const additionalTax = roundCurrency(Math.max(0, additionalAmount)*(taxPercent/100));
                let new_tax = roundCurrency(baseTax + additionalTax);
                $parentForm.find('.service-estimate-pricing__tax-value').text(new_tax.toFixed(2));
                tax = new_tax;
            }
            if ($parentForm.find('[data-sub-total-tips]').length>0) {
                tips = parseFloat($parentForm.find('[data-sub-total-tips]').text()) || 0;
            }
            let total = roundCurrency(sub_total + tax + tips);
            $parentForm.find('.service-estimate-pricing__total-value').text(total.toFixed(2));
            if (total>0) {
                $parentForm.find('.charge-btn').removeAttr('disabled');
                if($parentForm.find('.customer-payment-warning').length == 0){
                    $parentForm.find('.paid-cash-btn').removeAttr('disabled');
                }
            }else{
                $parentForm.find('.charge-btn, .paid-cash-btn').attr('disabled', 'disabled');
            }
        });

        $('body').on('click', '.charge-btn, .paid-cash-btn', function(e) {
            e.preventDefault();

            let currentElem = $(this);
            let order_id = currentElem.data('order-id');
            let action = currentElem.data('action');
            let type = currentElem.data('type');
            let typeAction = currentElem.data('type-action');
            let method = currentElem.data('method');

            let paymentId = currentElem.data('payment-id') ?? null;

            let additional_amount = $('#additional_input').val();
            let additional_comments = $('#payment_comments').val();

            let data = {
                type: type,
                additional_amount: additional_amount,
                additional_comments: additional_comments,
                method: method
            };
            if(paymentId != null)
                data.payment_id = paymentId

            $('.charge-modal').modal('hide');
            $('.modal.charge').modal('hide')
            $('.modal-backdrop').remove();
            $('.bb-preloader-container').show();
            $.ajax({
                type: 'POST',
                url: '/payments/' + order_id + '/' + action + (typeAction ? `/${typeAction}` : ''),
                data: data,
                success: function (response) {
                    if (action === 'paid-cash' || action === 'set-paid-cash') {
                        const url = new URL(window.location.href);

                        if (
                            url.searchParams.get('modal') === 'universal' &&
                            url.searchParams.get('step') === 'appointments' &&
                            url.searchParams.get('internal_step') === 'appointment'
                        ) {
                            url.searchParams.set('internal_step', 'payment');
                            window.location.href = url.toString();
                        } else {
                            window.location.reload();
                        }
                    }
                    $('.bb-preloader-container').hide();
                    $('#form-container').html(response);
                    if($('#success_payment-modal').length)
                        $('#success_payment-modal').modal('show');
                    if($('#failed_payment-modal').length)
                        $('#failed_payment-modal').modal('show');
                    if($('#success-action-modal').length)
                        $('#success-action-modal').modal('show');
                    if($('#failed-action-modal').length)
                        $('#failed-action-modal').modal('show');
                }
            });
        });

        $('body').on('click', '.internal-data-container .view-payment-details', function (e) {

            let type = $(this).data('type');
            $.ajax({
                method: 'POST',
                url: '/payments/get-form',
                data: {
                    form_type:  type,
                    payment_id: $(this).data('payment_id'),
                },
                success: function(response) {
                    $('#form-container').html(response);
                    $(`#customer-view-${type}-modal`).modal('show');
                }
            });
        });
    },

    calculateTax(sum, tax){
        if (sum >0 && tax>0) {
            let tax_value = sum*tax/100
            return roundCurrency(tax_value).toFixed(2);
        }else{
            return '0.00'
        }
    },

    refunds() {
        $('body').on('click', '.refund-modal-btn', function(e) {
            e.preventDefault();

            let currentElem = $(this);
            let payment_id = currentElem.data('payment-id');
            let action = currentElem.data('action');

            $('.bb-preloader-container').show();
            $.ajax({
                type: 'GET',
                url: '/payments/' + payment_id + '/' + action,
                success: function (response) {
                    $('.bb-preloader-container').hide();
                    $('#form-container').append(response);
                    $('.'+action+'-modal').modal('show');
                },
                error: function(response) {
                    $('.bb-preloader-container').hide();
                    console.log(response);
                }
            });
        });

        $('body').on('click', '.refund-charge-btn', function(e) {
            e.preventDefault();

            let saveBtn = new SaveButton('#refund-charge-modal');


            let currentElem = $(this);
            let payment_id = currentElem.data('payment-id');
            let action = currentElem.data('action');

            let data = {
                refund_amount: $('#refund_amount_input').val(),
                refund_details: $('#refund_details').val(),
            };
            //$('.modal-backdrop').remove();
            //$('.bb-preloader-container').show();
            saveBtn.startLoading()
            $.ajax({
                type: 'POST',
                url: '/payments/' + payment_id + '/' + action,
                data: data,
                success: function(response) {
                    saveBtn.stopLoading().then(() => {
                        saveBtn.showSuccess();
                    });
                    $('#form-container').append(response.modal);
                    $('#refund-charge-modal').modal('hide');
                    $('#success_payment-modal').modal('show');
                },
                error: function(response) {
                    saveBtn.stopLoading().then(() => {
                        saveBtn.showError(response.responseJSON.message)
                    });
                }
            });
        });
    },

    removeWarning(){
        $(document).on('click', '.remove_warning',function (e) {
            let class_id = $(this).data('class_id');
            let class_type = $(this).data('class_type');
            $.ajax({
                method: "POST",
                url: `/${class_type}/remove-warning`,
                data:{ class_id: class_id},
                success: function (response) {
                    $('.warning-modal').modal('hide');
                    // location.reload(true);
                    fetchTableData();
                }
            });
        });
    },

    autoRefresh(pathname){
        if (window.location.pathname == pathname) {
            this.clearAllIntervals();
            let interval = setInterval(function () {
                fetchTableData();
            }, 900000);
        }
    },

    clearAllIntervals(){
        for(var i = setInterval(''); i >= 0; i--){
            clearInterval(i);
        }
    },

    initPagination(){
        let section;
        if (window.location.pathname == '/payments') {
            section = new Section('payments', true);
            section.show();
        } else if (window.location.pathname == '/subscription') {
            section = new Section('subscriptions', true);
            section.show();
        }
    },

    serviceInvoiceInfoModal(){
        $('body:not(#customer-cab)').off('click', '#download-pdf-btn')
        .on('click', '#download-pdf-btn', (e)=>{
            let id = $(e.currentTarget).data('id');
            window.open(`/appointment/${id}/pdf`, '_blank');
        })

        $('body:not(#customer-cab)').off('click', '.view_full_invoice_info')
        .on('click', '.view_full_invoice_info', (e)=>{
            let type = $(e.currentTarget).data('type');
            $.ajax({
                method: 'POST',
                url: '/payments/get-form',
                data: {
                    form_type:  type,
                    payment_id: $(e.currentTarget).data('payment_id'),
                    volume: 'full'
                },
                success: function(response) {
                    new Promise((resolve)=>{
                        $('#form-container').find('.modal').modal('hide');
                        setTimeout(() => {
                            resolve();
                        }, 150);
                    }).then(()=>{
                        $('#form-container').html(response);
                        $(`#service-invoice-modal`).modal('show');
                    });
                }
            });
        });
    }
}
